import useProtectedFileToken from '../hooks/useProtectedFileToken';
import { Spin } from 'antd';

export default function ProtectedFileToken() {
  const { error, isLoading } = useProtectedFileToken();

  return (
    <div className="absolute inset-0 top-2 z-50 flex flex-col items-center justify-center gap-4 bg-white transition-all duration-200">
      <div className="flex flex-row items-center justify-center gap-2">
        {error ? <span>{error}</span> : <span>Opening protected file...</span>}
        {isLoading && <Spin />}
      </div>
    </div>
  );
}
